import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';

import React, { useState, useEffect, useRef, useContext } from 'react';

/* ################ IMPORTS OF PRIMEREACT ################*/
import { DataTable } from 'primereact/datatable';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from "primereact/inputtextarea";
import { InputSwitch } from 'primereact/inputswitch';

import { EnvContext } from '../Context/EnvProvider';
import { useAuthToken } from '../../hooks/useAuthToken';

import Grid from "@material-ui/core/Grid";

import '../../css/listBots.css';

import CampaignMessagesIntegrations from '../../integrations/CampaignMessagesIntegrations';

const campaignIntegration = new CampaignMessagesIntegrations();

let emptyCampaignMessage = {
    id: "",
    botId: "",
    messages: {
        title: "",
        message: "",
        validated: false,
    }
};
let options = [
    "Todas as mensagens", "Apenas não validados", "Apenas validados"
]



const CampaignMessages = () => {

    const [loading, setLoading] = useState(true);
    const [campaignMessages, setCampaignMessages] = useState();
    const [editMessageDialog, setEditMessageDialog] = useState(false);
    const [campaignMessageRow, setCampaignMessageRow] = useState(emptyCampaignMessage);
    const [expandedRows, setExpandedRows] = useState(null);
    const [filter, setFilter] = useState("Todas as mensagens");
    const [botId, setBotId] = useState(null);

    const toast = useRef(null);
    const dt = useRef(null);
    const { environment } = useContext(EnvContext);
    const { getAccessToken } = useAuthToken();


    useEffect(() => {
        const loadMessages = async () => {
            try {
                const authToken = await getAccessToken();
                
                if (filter === "Apenas validados") {
                    const data = await campaignIntegration.listMessagesTrue(environment.botApi, authToken);
                    setCampaignMessages(data);
                    setLoading(false);
                } else if (filter === "Apenas não validados") {
                    const data = await campaignIntegration.listMessagesFalse(environment.botApi, authToken);
                    setCampaignMessages(data);
                    setLoading(false);
                } else {
                    const data = await campaignIntegration.listMessages(environment.botApi, authToken);
                    setCampaignMessages(data);
                    setLoading(false);
                }
            } catch (error) {
                setLoading(false);
                console.error(error);
                toast.current?.show({
                    severity: "error",
                    summary: "Erro!",
                    detail: "Erro ao buscar Mensagens!.",
                    life: 5000,
                });
            }
        };
        
        loadMessages();
    }, [loading, environment, filter, getAccessToken]); 

    const onHide = (field) => {
        if (field === "editMessageDialog") {
            setEditMessageDialog(false);
        }
    };

    const editMessage = (rowData) => {
        setCampaignMessageRow(rowData);
        setBotId(rowData.botId);
        setEditMessageDialog(true);
    };
    const validatedTemplate = (rowData) => {
        return <span>
            {rowData.validated ? ("Sim") : ("Não")}
        </span>
    };
    const header1 = () => {
        return (
            <div className="p-d-flex p-jc-between">
                <h5 className="p-mx-0 p-my-1">Filtros</h5>
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <Dropdown value={filter} options={options} onChange={(e) => setFilter(e.value)} />
                </span>
            </div>
        )
    }
    const header = header1();

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-mr-2" onClick={() => editMessage(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => deleteMessage(rowData)} />
            </React.Fragment>
        );
    };
    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || "";
        let _campaignMessageRow = { ...campaignMessageRow };
        _campaignMessageRow[`${name}`] = val;

        setCampaignMessageRow(_campaignMessageRow);
    };
    const saveCampaignMessage = async () => {
        setLoading(true);
        try {
            const authToken = await getAccessToken();
            
            let templateMessage = {
                title: campaignMessageRow.title,
                message: campaignMessageRow.message,
                validated: campaignMessageRow.validated
            }
            await campaignIntegration.updateCampaignMessage(environment.botApi, templateMessage, botId, authToken);
            toast.current.show({ severity: "success", summary: "Atenção!", detail: "Mensagem alterada com sucesso!", life: 5000 });
            setEditMessageDialog(false);
        } catch (error) {
            console.error(error);
            toast.current.show({
                severity: "error",
                summary: "Erro!",
                detail: "Erro ao salvar mensagem!.",
                life: 5000,
            });
        }
    };
    const EditDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={() => onHide("editMessageDialog")} />

            <Button label="Salvar" icon="pi pi-check" className="p-button-text" onClick={saveCampaignMessage} loading={loading} />
        </React.Fragment>
    );

    const deleteMessage = async (rowData) => {
        setLoading(true);
        try {
            const authToken = await getAccessToken();
            
            await campaignIntegration.deleteMessage(environment.botApi, rowData.title, botId, authToken);
            toast.current.show({ severity: "success", summary: "Atenção!", detail: "Mensagem excluida com sucesso!", life: 5000 });
        } catch (error) {
            console.error(error);
            toast.current.show({
                severity: "error",
                summary: "Erro!",
                detail: "Erro ao Excluir Mensagem!.",
                life: 5000,
            });
        }
    };
    const rowExpansionTemplate = (data) => {
        return (
            <div className="orders-subtable">
                <DataTable ref={dt} value={data.messages} resizableColumns emptyMessage="Nenhum Registro encontrado!" loading={loading}>
                    <Column field="title" header="Titulo da Mensagem" style={{ textOverflow: "ellipsis" }} sortable></Column>
                    <Column field="message" header="Conteúdo da Mensagem" style={{ maxWidth: "30vw", textOverflow: "ellipsis" }} sortable></Column>
                    <Column header="Aprovado" field="validated" body={validatedTemplate} style={{ maxWidth: "6vw" }} sortable></Column>
                    <Column body={actionBodyTemplate} style={{ maxWidth: "5vw" }}></Column>
                </DataTable>
            </div>
        );
    }

    return (
        <div className="listBot">

            <div className="card">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/">Home</Link>
                        </li>
                        <li className="breadcrumb-item active">
                            <span>Mensagens da Campanha</span>
                        </li>
                    </ol>
                </nav>

            </div>

            <div className="card">
                <Toast ref={toast} />

                <DataTable value={campaignMessages} header={header} expandedRows={expandedRows} onRowToggle={(e) => setExpandedRows(e.data)}
                    responsiveLayout="scroll"
                    rowExpansionTemplate={rowExpansionTemplate} dataKey="id">
                    <Column expander style={{ width: '3em' }} />
                    <Column field="id" header="Id" sortable />
                    <Column field="botId" header="botId" sortable />
                    <Column field="botName" header="Nome do bot" sortable />
                    <Column field="tenantId" header="tenantId" sortable />
                </DataTable>
            </div>
            <Dialog visible={editMessageDialog} modal baseZIndex={1450} onHide={() => onHide("editMessageDialog")} footer={EditDialogFooter} header="Editar mensagens da Campanha" style={{ width: "70vw" }}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <span className="p-float-label">
                            <InputText
                                id="title"
                                name="title"
                                style={{ display: "flex", width: "100%", marginTop: "20px" }}
                                value={campaignMessageRow.title}
                                disabled
                                autoresize="true"
                            />
                            <label htmlFor="title">Titulo da Mensagem</label>
                        </span>
                    </Grid>
                    <Grid item xs={12}>
                        <span className="p-float-label">
                            <InputTextarea id="message" name="message" style={{ display: "flex", width: "100%" }} rows={7} value={campaignMessageRow.message} onChange={(e) => onInputChange(e, "message")} autoresize="true" />
                            <label htmlFor="message">Conteúdo da Mensagem</label>
                        </span>
                    </Grid>
                    <Grid item xs={12}>
                        <h5 style={{ marginTop: "0px" }}>Aprovado:</h5>
                        <InputSwitch id="validated" name="validated" style={{ display: "flex" }} checked={campaignMessageRow.validated} onChange={(e) => onInputChange(e, "validated")} />
                    </Grid>
                </Grid>
            </Dialog>
        </div>
    );
}
export default CampaignMessages;
